import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-header-task",
  "use": "app-icon-header-task-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"app-icon-header-task\"><g transform=\"translate(3 3)\" stroke=\"#9EA4B3\" stroke-width=\"2\" fill=\"none\" fill-rule=\"evenodd\"><rect x=\"1\" y=\"1\" width=\"16\" height=\"17\" rx=\"1\" /><path d=\"M6 7h6M6 12h3\" stroke-linecap=\"round\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol